import { j as a } from "../../jsx-runtime-B6kdoens.js";
import { forwardRef as s } from "react";
import { I as c } from "../../IconBase-CxZyIWw2.js";
import { i as j } from "../../IconBase-CxZyIWw2.js";
import { c as m, f as p } from "../../create-component-CBAeEoQ6.js";
const f = m(
  "Icon",
  p(
    ({ fillMethod: o, name: t, image: n, ...r }, e) => {
      if (t)
        throw new Error("Icon: `name` prop has been removed! This component is now only for rendering arbitrary icon SVGs via an `image` prop. Use specifc icons (ex. `<PlaceholderIcon />`) or the `<DynamicIcon />` component if you need to render an icon by name.");
      return n ? /* @__PURE__ */ a.jsx(
        c,
        {
          ref: e,
          fillMethod: o,
          image: n,
          ...r
        }
      ) : null;
    }
  )
), x = s(
  ({
    icon: o,
    component: t = f,
    ...n
  }, r) => {
    if (!o)
      return null;
    let e;
    if (typeof o == "function") {
      const i = o;
      e = /* @__PURE__ */ a.jsx(i, { ref: r });
    } else
      e = o;
    return /* @__PURE__ */ a.jsx(t, { image: e, ref: r, ...n });
  }
);
export {
  f as Icon,
  x as IconRenderer,
  j as iconSizeValueMap
};
//# sourceMappingURL=index.js.map
